<template>
  <BannerBlock titleClass="">
    <template v-slot:title>
      <p v-html="$t('banner.thankAdvance')"></p>
    </template>
    <template v-slot:message>
      {{$t("banner.thankAdvanceDesc")}}
    </template>
    <!-- <template v-slot:actions>
      <button class="btn btn-warning">Upgrade Now</button>
    </template> -->
    <template v-slot:default>
      <!-- <img class="ml-auto" src="@/core/assets/Dashboard/Banner/Thanks/advanced.svg" /> -->
      <!-- <div class="bg ml-auto col-sm-4 d-none d-sm-unset"></div> -->
      <div class="banner-image col-sm-5 d-none d-sm-flex">
        <img class="banner-img" :src="publicPath + require('@/core/assets/Dashboard/Banner/Thanks/professional.svg')" />
      </div>
    </template>
  </BannerBlock>
</template>

<script>
import BannerBlock from "../../BannerBlock";
export default {
  name: "ThankAdvanced",
  components: {
    BannerBlock
  },
  data() {
    return {
      // dayLeft: 2
    };
  },
  computed: {
  }
};
</script>
<style lang="scss" scoped>
// .bg {
//   background-image: url(~@/core/assets/Dashboard/Banner/Thanks/advanced.svg);
//   width: 288px;
// }
</style>
